import * as React from 'react';
import { observer } from 'mobx-react';

import './App.css';
import { withAuthenticator } from 'aws-amplify-react';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

@observer
class SecureApp extends React.Component<{}, {}> {
  render() {
    return (
      <Router>
        <App />
      </Router>
    );
  }
}

// Override AWS Cognito error messages so they are more user friendly.
// const errorMessageMap = (message: any) => {
//   const PASSWORD_POLICY_MSG = 'Password must have at least 8 characters, ' +
//     'at least one lowercase character, ' +
//     'at least one uppercase character ' + 
//     'at least one special character ' +
//     'and at least one numeric character.';
  
//   if (/The.*first.*parameter.*should.*be*/i.test(message)) {
//     return 'Username is required.';
//   }

//   if (/Username.*email.*format*/i.test(message)) {
//     return 'Username can not be your email address. It should be something like jsmith or johnsmith. ' 
//       + 'Note: You will be able to sign in with either your Username or Email.';
//   }

//   if (/email.*attribute.*required*/i.test(message)) {
//     return 'Email is required.';
//   }

//   if (/password.*length.*greater.*6*/i.test(message)) {
//     return PASSWORD_POLICY_MSG;
//   }

//   if (/Password.*not.*long.*enough*/i.test(message)) {
//     return PASSWORD_POLICY_MSG;
//   }

//   if (/Password.*must.*have.*lowercase.*characters*/i.test(message)) {
//     return 'Password must have at least one lowercase character.';
//   }

//   if (/Password.*must.*have.*uppercase.*characters*/i.test(message)) {
//     return 'Password must have at least one uppercase character.';
//   }

//   if (/Password.*must.*have.*numeric.*characters/i.test(message)) {
//     return 'Password must have at least one numeric character.';
//   }

//   if (/Password.*must.*have.*symbol.*characters/i.test(message)) {
//     return 'Password must have at least one special character. (i.e: ! )';
//   }

//   if (/Invalid.*phone.*number.*format/i.test(message)) {
//     return 'Phone Number must have a +1 in front of it.';
//   }

//   return message;
// };

// // const displaySignoutHeader: boolean = false;
// // export default withAuthenticator(SecureApp, displaySignoutHeader, [
// //   <Authenticator key={1} errorMessage={errorMessageMap} />
// // ]);

const appTheme = {
  button: { backgroundColor: "#337ab7" }
};
const displaySignoutHeader: boolean = false;
const signUpConfig = {
  hideAllDefaults: true,
  signUpFields: [
    {
      label: 'Email',
      key: 'username',
      required: true,
      placeholder: 'e.g. example@example.com',
      type: 'email',
      displayOrder: 1
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      placeholder: 'Password',
      type: 'password',
      displayOrder: 2
    },
    {
      label: 'First Name',
      key: 'given_name',
      required: true,
      placeholder: 'e.g. MaryAnn',
      displayOrder: 3
    },
    {
      label: 'Last Name',
      key: 'family_name',
      required: true,
      placeholder: 'e.g. Marks',
      displayOrder: 4
    },
    {
      label: 'Phone Number',
      key: 'phone_number',
      required: true,
      placeholder: 'e.g. 3115551212',
      displayOrder: 5
    }
  ],
}
// export default SecureApp;
export default withAuthenticator(SecureApp, displaySignoutHeader, [], null, appTheme, signUpConfig);
// export default withAuthenticator(SecureApp, true);
